import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (!['company_admin', 'super_admin'].includes(user.role)) {
        setError('هذه الصفحة مخصصة لمديري الشركات والمدير العام فقط');
        return;
      }
      navigate(user.role === 'super_admin' ? '/admin/super' : '/admin');
    } catch (err) {
      if (!err.response) {
        setError('تعذّر الاتصال بالخادم — قد يكون الخادم في وضع السكون، أعد المحاولة بعد 30 ثانية');
      } else {
        setError(err.response.data?.message || 'بيانات الدخول غير صحيحة');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="سافر" className="w-20 h-20 object-cover rounded-[22%] mx-auto mb-3" />
          <p className="text-gray-500 text-sm">بوابة الشركات والمدير العام</p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-600 rounded-lg px-4 py-3 mb-4 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">البريد الإلكتروني</label>
            <input type="email" value={form.email} required placeholder="admin@company.com"
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">كلمة المرور</label>
            <input type="password" value={form.password} required placeholder="••••••••"
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
          </div>
          <div className="text-left">
            <Link to="/admin/forgot-password" className="text-xs text-blue-600 hover:underline font-medium">
              نسيت كلمة المرور؟
            </Link>
          </div>
          <button type="submit" disabled={loading}
            className="w-full bg-blue-700 hover:bg-blue-800 disabled:bg-blue-400 text-white font-semibold py-3 rounded-lg transition">
            {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>

        <div className="mt-6 pt-6 border-t border-gray-100 text-center">
          <p className="text-sm text-gray-500">
            شركة جديدة؟{' '}
            <Link to="/company-register" className="text-blue-600 hover:underline font-medium">
              سجّل شركتك الآن
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
